// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatFilledSvg from "@fishx/icons-svg/es/asn/WechatFilled";
import FishxIcon from '../components/FishxIcon';

var WechatFilled = function WechatFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WechatFilledSvg
  }));
};

WechatFilled.displayName = 'WechatFilled';
export default React.forwardRef(WechatFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WechatFilled.js
// module id = 4394
// module chunks = 0